var map = {
	"./anglerfish.png": 82811,
	"./bluejellyfish.png": 56158,
	"./catfish.png": 65071,
	"./crocodile.png": 31722,
	"./dolphin.png": 3376,
	"./dory.png": 84143,
	"./eel.png": 1095,
	"./fresh.png": 21213,
	"./freshpred.png": 70055,
	"./freshprey.png": 52899,
	"./gary.png": 57407,
	"./killerwhale.png": 81671,
	"./koifish.png": 89572,
	"./larry.png": 17074,
	"./lionfish.png": 99586,
	"./mrkrab.png": 21254,
	"./mrspuff.png": 89830,
	"./pinkjellyfish.png": 72392,
	"./pixelFish.png": 58052,
	"./predFresh.png": 57900,
	"./predSalt.png": 52009,
	"./preyFresh.png": 67536,
	"./preySalt.png": 55214,
	"./salt.png": 92494,
	"./saltpred.png": 60261,
	"./saltprey1.png": 36666,
	"./sardine.png": 55686,
	"./seahorse.png": 31198,
	"./shark.png": 24251,
	"./snail.png": 94244,
	"./spongebob.png": 80534,
	"./squidward.png": 212,
	"./sunfish.png": 58652,
	"./swordfish.png": 54163,
	"./tank.png": 41052,
	"./troutfish.png": 96972,
	"./whale.png": 53490,
	"./whaleshark.png": 54586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96303;